import React from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import { ThemeMode, useThemeMode } from '../contexts/ThemeContext';

const OPTIONS: { value: ThemeMode; label: string; icon: React.ElementType }[] = [
  { value: 'system', label: 'Système', icon: Monitor },
  { value: 'light', label: 'Clair', icon: Sun },
  { value: 'dark', label: 'Sombre', icon: Moon },
];

/** Sélecteur d'apparence (Système / Clair / Sombre) — même logique que le mobile. */
const AppearanceSelector: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const { mode, setMode } = useThemeMode();

  if (compact) {
    return (
      <div className="inline-flex rounded-xl border border-dark-700 bg-dark-800 p-1">
        {OPTIONS.map(({ value, icon: Icon }) => {
          const active = mode === value;
          return (
            <button
              key={value}
              type="button"
              title={value === 'system' ? 'Système' : value === 'light' ? 'Clair' : 'Sombre'}
              onClick={() => setMode(value)}
              className={`rounded-lg p-2 transition-colors ${
                active
                  ? 'bg-primary-500 text-onPrimary'
                  : 'text-dark-400 hover:text-white hover:bg-dark-700'
              }`}
            >
              <Icon className="h-4 w-4" />
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="bg-dark-800 border border-dark-700 rounded-xl p-4 space-y-3">
      <div>
        <h3 className="text-white font-semibold text-sm">Apparence</h3>
        <p className="text-dark-400 text-xs mt-0.5">
          Choisis le thème de l&apos;application (clair, sombre, ou suivi du système).
        </p>
      </div>
      <div className="flex rounded-xl bg-dark-900/80 p-1 gap-1">
        {OPTIONS.map(({ value, label, icon: Icon }) => {
          const active = mode === value;
          return (
            <button
              key={value}
              type="button"
              onClick={() => setMode(value)}
              className={`flex-1 flex items-center justify-center gap-2 rounded-lg py-2.5 text-sm font-medium transition-colors ${
                active
                  ? 'bg-primary-500 text-onPrimary shadow-glow-green'
                  : 'text-dark-300 hover:text-white hover:bg-dark-800'
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AppearanceSelector;
